import { getIconProps, type IconProps } from '#types'

/**
 * Checkmark icon - success indicator
 * 
 * Used for confirmation, success states, completed actions.
 * Represents successful completion or validation.
 * 
 * @example
 * ```tsx
 * <button>
 *   <CheckmarkIcon className="h-4 w-4" /> Saved
 * </button>
 * ```
 */
export function CheckmarkIcon(props: IconProps) {
  return (
    <svg
      {...getIconProps(props)}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M20 6L9 17l-5-5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
